import { ClassNameProps, Column, Heading, HeadingLevel, Paragraph, Row, StyleProps, Tooltip } from "@hex-insights/core";
import { Icon } from "../../../../../Components/Icon";
import { Tile } from "../../../../../Components/Tile";

export type CourseLessonPlanStatusesTileProps = {
	headingLevel?: HeadingLevel;
} & Partial<ClassNameProps & StyleProps>;

export function CourseLessonPlanStatusesTile({
	headingLevel = 2,
	className,
	style,
}: CourseLessonPlanStatusesTileProps) {
	return (
		<Tile className={className} style={style}>
			<Tile.Header>
				<Heading level={headingLevel} noMargin>
					Lesson Plans
				</Heading>
			</Tile.Header>
			<Tile.Body>
				<CourseLessonPlanStatuses />
			</Tile.Body>
		</Tile>
	);
}

export type CourseLessonPlanStatusesProps = Partial<ClassNameProps & StyleProps>;

export function CourseLessonPlanStatuses({ className, style }: CourseLessonPlanStatusesProps) {
	return (
		<Row justify="space-around" className={className} style={style}>
			<Column justify="spaced-start" align="center" verticalSpacing="0.5rem">
				<strong>M</strong>
				<LessonPlanStatus status="complete" />
			</Column>
			<Column justify="spaced-start" align="center" verticalSpacing="0.5rem">
				<strong>T</strong>
				<LessonPlanStatus status="complete" />
			</Column>
			<Column justify="spaced-start" align="center" verticalSpacing="0.5rem">
				<strong>W</strong>
				<LessonPlanStatus status="in-progress" />
			</Column>
			<Column justify="spaced-start" align="center" verticalSpacing="0.5rem">
				<strong>T</strong>
				<LessonPlanStatus status="not-started" />
			</Column>
			<Column justify="spaced-start" align="center" verticalSpacing="0.5rem">
				<strong>F</strong>
				<LessonPlanStatus status="not-started" />
			</Column>
		</Row>
	);
}

type LessonPlanStatusProps = {
	status: "complete" | "in-progress" | "not-started";
};

function LessonPlanStatus({ status }: LessonPlanStatusProps) {
	let color = "";
	let StatusIcon = Icon.WarningOctagon;
	let label = "";
	let text = "";
	switch (status) {
		case "complete":
			color = "var(--theme-colors__green)";
			StatusIcon = Icon.CheckCircle;
			label = "Complete";
			text = "Lesson plan created on June 26, 2023";
			break;
		case "in-progress":
			color = "var(--theme-colors__yellow)";
			StatusIcon = Icon.Clock;
			label = "In Progress";
			text = "Lesson plan is in progress";
			break;
		case "not-started":
			color = "var(--theme-colors__orange)";
			StatusIcon = Icon.WarningOctagon;
			label = "Not Started";
			text = "Lesson plan has not started";
			break;
	}

	return (
		<Tooltip.Container>
			<Tooltip style={{ width: "9.125rem" }}>
				<Tooltip.Header style={{ padding: "0.75rem 0.75rem 0" }}>
					<Row justify="spaced-start" align="center" horizontalSpacing="0.375rem">
						<StatusIcon size={16} color={color} style={{ flexShrink: 0 }} />{" "}
						<strong className="nowrap" style={{ fontSize: "1rem" }}>
							{label}
						</strong>
					</Row>
				</Tooltip.Header>
				<Tooltip.Body style={{ padding: "0.25rem 0.75rem 0.75rem" }}>
					<Paragraph style={{ fontSize: "0.75rem" }}>{text}</Paragraph>
				</Tooltip.Body>
			</Tooltip>

			<StatusIcon size={32} color={color} />
		</Tooltip.Container>
	);
}
